/** A pasted URL becomes just its domain; anything else is kept as typed. */
export const cleanWebsiteField = (rawText: string) => {
  try {
    const url = new URL(rawText);
    return url.hostname;
  } catch (e) {
    return null;
  }
};
